import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import type { CanActivateFn, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { parseAuthorizedUser } from '@app/domain/helpers';
import { AuthService } from '@app/services/auth/auth';

const MAGIC_LINK_PARAM = 'magic-link';

export const magicLinkGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  const token = route.queryParamMap.get(MAGIC_LINK_PARAM);

  if (!token || !isPlatformBrowser(platformId)) {
    return true;
  }

  const urlWithoutToken = (): UrlTree => {
    const tree = router.parseUrl(state.url);

    delete tree.queryParams['magic-link'];

    return tree;
  };

  return authService.magicLogin(token).pipe(
    map(response => {
      const user = parseAuthorizedUser(response.data);

      if (user) {
        authService.setMagicSession(user);
      }

      return urlWithoutToken();
    }),
    catchError(() => of(urlWithoutToken())),
  );
};
